import React from 'react';
import { Modal, Button } from 'antd';
import { CodeOutlined } from '@ant-design/icons';

interface EmailHtmlModalProps {
  visible: boolean;
  onClose: () => void;
  htmlContent: string;
  emailSubject?: string;
}

export const EmailHtmlModal: React.FC<EmailHtmlModalProps> = ({
  visible,
  onClose,
  htmlContent,
  emailSubject
}) => {
  return (
    <Modal
      title={
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <CodeOutlined />
          HTML View{emailSubject ? `: ${emailSubject}` : ''}
        </div>
      }
      open={visible}
      onCancel={onClose}
      width={800}
      style={{ top: 20 }}
      footer={[
        <Button key="close" onClick={onClose}>
          Close
        </Button>
      ]}
    >
      <div
        style={{
          maxHeight: '70vh',
          overflow: 'auto',
          border: '1px solid #d9d9d9',
          borderRadius: '6px',
          backgroundColor: '#fafafa'
        }}
      >
        {/* Render HTML content in sandboxed iframe for security */}
        <iframe
          srcDoc={htmlContent}
          style={{
            width: '100%',
            minHeight: '400px',
            border: 'none',
            borderRadius: '6px',
            backgroundColor: 'white'
          }}
          sandbox="allow-same-origin"
          title="Email HTML Content"
        />
      </div>
      
      {/* Raw HTML source view */}
      <div style={{ marginTop: '16px' }}>
        <details>
          <summary style={{ cursor: 'pointer', color: '#666' }}>
            View HTML Source
          </summary>
          <pre
            style={{
              marginTop: '8px',
              padding: '12px',
              backgroundColor: '#f5f5f5',
              border: '1px solid #d9d9d9',
              borderRadius: '4px',
              fontSize: '12px',
              maxHeight: '200px',
              overflow: 'auto',
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-all'
            }}
          >
            {htmlContent}
          </pre>
        </details>
      </div>
    </Modal>
  );
};